/* eslint-disable react/no-danger */
import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './style.module.css';
import { Checkbox } from '@mui/material';
import { Dialog } from '@material-ui/core';
import { keyboard, scribble, buddyReferralCloseIcon } from 'assets/icons';
import SignatureCanvas from 'react-signature-canvas';
import BackButton from 'layouts/RegistrationLayoutNew/Buttons/BackButton';

const TermsConditions = ({
  userExist,
  selectedClub,
  selectedPlan,
  card,
  emailAddress,
  userPersonalInfo,
  setTermsAccept,
  termsAccept,
  plan,
  onNext,
  isMobile,
  onBackTerms,
  getPaymentDetails,
  referralPerson,
  updateOlsTracking,
  trackingId,
  title,
  termsTextData,
  setTypedSignImage,
  drawSignImage,
  setDrawSignImage,
  activeSignTab,
  setActiveSignTab,
}) => {
  const scrollContainerRef = useRef(null);
  const checkbox1Ref = useRef(null);
  const checkbox2Ref = useRef(null);
  const parts = (userPersonalInfo?.birthday).split('/');
  const [month, day, year] = parts;
  const [isCancellationPopupOpen, setIsCancellationPopupOpen] = useState(false);
  const [isTabsEnabled, setIsTabsEnabled] = useState(false);
  const [typedSignature, setTypedSignature] = useState('');
  const offscreenCanvasRef = useRef(null);
  const typesSignatureBoxRef = useRef(null);
  const signedCanvasRef = useRef(null);
  const [forceRender, setForceRender] = useState(false);
  const termsOfServiceUrl = process.env.REACT_APP_TERMS_OF_SERVICE_URL;
  const privacyPolicyUrl = process.env.REACT_APP_PRIVACY_POLICY_URL;

  var userDetailsForCreation = {
    onlyPreview: true,
    gender: userPersonalInfo?.gender,
    firstName: userPersonalInfo?.firstName,
    lastName: userPersonalInfo?.lastName,
    dateOfBirth: `${year}-${month}-${day}`,
    email: emailAddress,
    phoneNumber: parseInt(userPersonalInfo?.phone.replace(/[^0-9]/g, '')),
    contactAddressLine1: userPersonalInfo?.address,
    contactCity: userPersonalInfo?.city,
    contactState: userPersonalInfo?.state,
    contactZip: userPersonalInfo?.zipCode,
    emergencyContactName: userPersonalInfo?.emergencyContactName,
    emergencyContactPhone: parseInt(
      userPersonalInfo?.emergencyContactPhone.replace(/[^0-9]/g, '')
    ),
    homeClubId: parseInt(selectedClub?.clubautomationclubidC),
    membershipId: selectedPlan?.id,
    // memberPortalPassword: 'A9cebc648-2e9e-4c6d-8c7a-6ea5ff36d',
    paymentMethod: 'credit card',
    eftAuthAccept: true,
    signature: userPersonalInfo?.firstName + ' ' + userPersonalInfo?.lastName,
    billingAddressLine1: userPersonalInfo?.address,
    billingCity: userPersonalInfo?.city,
    billingState: userPersonalInfo?.state,
    billingZip: userPersonalInfo?.zipCode,
    termsAccept: termsAccept,
    waiverReleaseAccept: true,
    billingName: userPersonalInfo?.firstName + ' ' + userPersonalInfo?.lastName,
    i4goUniqueId: card?.i4goUniqueId,
    maskedCardNumber: card?.cardNumber,
    cardExpirationMonth: parseInt(card?.cardExpirationMonth),
    cardExpirationYear: parseInt(card?.cardExpirationYear),
    referredByCaId: Object.keys(referralPerson).length !== 0 ? referralPerson?.caID : '',
    referredByName: Object.keys(referralPerson).length !== 0 ? referralPerson.name : '',
    hubspotreferralbyid:
      Object.keys(referralPerson).length !== 0 ? referralPerson.referralId : '',
  };

  var userDetailsForUpdation = {
    onlyPreview: true,
    gender: userPersonalInfo?.gender,
    firstName: userPersonalInfo?.firstName,
    lastName: userPersonalInfo?.lastName,
    dateOfBirth: `${year}-${month}-${day}`,
    email: 'x5Tt34FB4Fzw@gmail.com',
    phoneNumber: parseInt(userPersonalInfo?.phone.replace(/[^0-9]/g, '')),
    contactAddressLine1: userPersonalInfo?.address,
    contactCity: userPersonalInfo?.city,
    contactState: userPersonalInfo?.state === '' ? 'CA' : userPersonalInfo?.state,
    contactZip: userPersonalInfo?.zipCode,
    emergencyContactName: userPersonalInfo?.emergencyContactName,
    emergencyContactPhone: parseInt(
      userPersonalInfo?.emergencyContactPhone.replace(/[^0-9]/g, '')
    ),
    homeClubId: parseInt(selectedClub?.clubautomationclubidC),
    membershipId: selectedPlan?.id,
    // memberPortalPassword: 'A9cebc648-2e9e-4c6d-8c7a-6ea5ff36d',
    paymentMethod: 'credit card',
    eftAuthAccept: true,
    signature: userPersonalInfo?.firstName + ' ' + userPersonalInfo?.lastName,
    billingAddressLine1: userPersonalInfo?.address,
    billingCity: userPersonalInfo?.city,
    billingState: userPersonalInfo?.state === '' ? 'CA' : userPersonalInfo?.state,
    billingZip: userPersonalInfo?.zipCode,
    termsAccept: termsAccept,
    waiverReleaseAccept: true,
    billingName: userPersonalInfo?.firstName + ' ' + userPersonalInfo?.lastName,
    i4goUniqueId: card?.i4goUniqueId,
    maskedCardNumber: card?.cardNumber,
    cardExpirationMonth: parseInt(card?.cardExpirationMonth),
    cardExpirationYear: parseInt(card?.cardExpirationYear),
    referredByCaId: Object.keys(referralPerson).length !== 0 ? referralPerson?.caID : '',
    referredByName: Object.keys(referralPerson).length !== 0 ? referralPerson.name : '',
    hubspotreferralbyid:
      Object.keys(referralPerson).length !== 0 ? referralPerson.referralId : '',
  };

  // testOLSemailForTC@gmail.com
  const handleScroll = () => {
    const scrollContainer = scrollContainerRef.current;
    const scrolledToBottom =
      scrollContainer.scrollHeight - scrollContainer.scrollTop - 100 <
      scrollContainer.clientHeight;
    setTermsAccept(scrolledToBottom);
  };

  const handleCheckboxChange = () => {
    if (checkbox1Ref.current.checked && checkbox2Ref.current.checked) {
      setIsTabsEnabled(true);
    } else {
      setIsTabsEnabled(false);
    }
    if (!checkbox1Ref.current.checked || !checkbox2Ref.current.checked) {
      setActiveSignTab('type');
    }
  };
  const handleSignature = event => {
    setTypedSignature(event.target.value);
    setForceRender(!forceRender);
  };

  const handleClear = () => {
    if (activeSignTab === 'type') {
      setTypedSignature('');
    } else {
      signedCanvasRef.current.clear();
      setDrawSignImage(null);
    }
  };

  useEffect(() => {
    if (typedSignature) {
      const offscreenCanvas = offscreenCanvasRef.current;
      offscreenCanvas.width = 800;
      const context = offscreenCanvas.getContext('2d');

      const typesSignatureBox = typesSignatureBoxRef.current;
      const computedStyle = window.getComputedStyle(typesSignatureBox);

      // Get computed styles
      const fontFamily = computedStyle.fontFamily;
      let fontSize = parseFloat(computedStyle.fontSize); // Convert font size to a number
      fontSize = fontSize * 1.8;
      offscreenCanvas.height = fontSize * 1.8;
      // Set updated font style on canvas
      context.font = `${fontSize}px ${fontFamily}`;
      context.textAlign = 'center';
      context.textBaseline = 'middle';

      // Clear previous content
      context.clearRect(0, 0, offscreenCanvas.width, offscreenCanvas.height);

      // Draw the typed signature
      context.fillText(
        typedSignature,
        offscreenCanvas.width / 2,
        offscreenCanvas.height / 2
      );

      // Get the image data
      const typedSignatureImage = offscreenCanvas.toDataURL('image/png');
      setTypedSignImage(typedSignatureImage);
    }
  }, [typedSignature]);

  useEffect(() => {
    if (activeSignTab === 'draw' && drawSignImage) {
      signedCanvasRef.current.clear();
      setDrawSignImage(null);
    }
  }, [activeSignTab]);

  const handleNext = async () => {
    if (checkbox1Ref.current.checked && checkbox2Ref.current.checked && !userExist) {
      let data = {
        user: userDetailsForCreation,
        isPhotoUpload: false,
        photo: null,
      };
      await getPaymentDetails(data);
      onNext();
    } else if (
      checkbox1Ref.current.checked &&
      checkbox2Ref.current.checked &&
      userExist
    ) {
      let data = {
        user: userDetailsForUpdation,
        isPhotoUpload: false,
        photo: null,
      };
      await getPaymentDetails(data);
      onNext();
    }
    handleTrackingApi();
  };

  const handleTrackingApi = () => {
    const data = {
      session: trackingId,
      email: emailAddress,
      currentPage: title,
      data: null,
      isFormerMember: userExist,
      isReferral: Object.keys(referralPerson).length !== 0,
      referrerName: Object.keys(referralPerson).length !== 0 ? referralPerson.name : null,
      referrerCaid:
        Object.keys(referralPerson).length !== 0 ? referralPerson?.caID : null,
    };
    updateOlsTracking(data);
  };

  const handleBack = () => {
    onBackTerms();
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    setActiveSignTab('type');
  }, []);
  return (
    <>
      <div className={`${styles.container} ${isMobile ? styles.mobile : ''}`}>
        <div
          className={`${styles.scroll} ${isMobile ? styles.mobile : ''}`}
          ref={scrollContainerRef}
          onScroll={handleScroll}
          style={{
            maxHeight: '350px',
            overflowY: 'scroll',
            padding: '10px',
          }}
        >
          <p
            className={`${styles.card} ${isMobile ? styles.mobile : ''}`}
            dangerouslySetInnerHTML={{
              __html: termsTextData?.termsAndConditionsDetails.replace(
                /<p>/g,
                '<p style="font-family: Montserrat-light;">'
              ),
            }}
          />
        </div>

        <div className={styles.checkboxWrapper}>
          <div className={`${styles.checkbox1} ${isMobile ? styles.mobile : ''}`}>
            <Checkbox
              inputRef={checkbox1Ref}
              onClick={() => handleCheckboxChange()}
              disabled={!termsAccept}
              size={isMobile ? 'large' : 'large'}
              sx={{
                '& .MuiSvgIcon-root': {
                  color: termsAccept === true ? 'var(--orange-color)' : 'none',
                },
                '&.Mui-checked': {
                  color: 'var(--orange-color)',
                },
              }}
            />
            <label
              className={`${styles.label} ${isMobile ? styles.mobile : ''} `}
              htmlFor="myCheckbox"
            >
              I authorize FITNESS SF to initiate debit entries to my account as indicated
              until revoked in writing, with the understanding that all monthly
              memberships must be billed at least once before cancellation.
            </label>
          </div>
          <div className={`${styles.checkbox2} ${isMobile ? styles.mobile : ''}`}>
            <Checkbox
              inputRef={checkbox2Ref}
              onClick={() => handleCheckboxChange()}
              disabled={!termsAccept}
              size={isMobile ? 'large' : 'large'}
              sx={{
                '& .MuiSvgIcon-root': {
                  color: termsAccept === true ? 'var(--orange-color)' : 'none',
                },
                '&.Mui-checked': {
                  color: 'var(--orange-color)',
                },
              }}
            />
            <label
              className={`${styles.label} ${isMobile ? styles.mobile : ''} `}
              htmlFor="myCheckbox"
            >
              I hereby acknowledge that I understand the FITNESS SF{' '}
              <span
                className={styles.policyText}
                onClick={() => setIsCancellationPopupOpen(true)}
              >
                Cancellation Policy
              </span>{' '}
              and procedure.
            </label>
          </div>
        </div>

        <div className={styles.innerCard}>
          <div className={styles.tabs}>
            {/* Tab for "TYPE SIGNATURE" */}
            {activeSignTab === 'type' ? (
              <button
                onClick={() => isTabsEnabled && setActiveSignTab('type')}
                className={!isTabsEnabled ? styles.disableTab : styles.tab}
                disabled={!isTabsEnabled}
              >
                <img src={keyboard} alt="icon" className={styles.logo} />
                TYPE SIGNATURE
              </button>
            ) : (
              <p
                className={styles.inactiveTab}
                onClick={() => isTabsEnabled && setActiveSignTab('type')}
                disabled={!isTabsEnabled}
              >
                TYPE SIGNATURE
              </p>
            )}

            {/* Tab for "DRAW SIGNATURE" */}
            {activeSignTab === 'draw' ? (
              <button
                onClick={() => {
                  isTabsEnabled && setActiveSignTab('draw');
                }}
                disabled={!isTabsEnabled}
                className={styles.tab}
              >
                {activeSignTab === 'draw' && (
                  <img src={scribble} alt="icon" className={styles.logo} />
                )}
                DRAW SIGNATURE
              </button>
            ) : (
              <p
                className={!isTabsEnabled ? styles.disableTabHover : styles.inactiveTab}
                disabled={!isTabsEnabled}
                onClick={() => {
                  isTabsEnabled && setActiveSignTab('draw');
                }}
              >
                DRAW SIGNATURE
              </p>
            )}
          </div>

          {/* Content for each tab */}
          {activeSignTab === 'type' ? (
            <div className={styles.contentContainer}>
              <p className={styles.inputLabel}>Type Signature</p>
              <input
                type="text"
                value={typedSignature}
                onChange={handleSignature}
                className={styles.input}
                disabled={!isTabsEnabled}
                onPaste={e => {
                  e.preventDefault();
                  alert('Pasting is disabled for this field.');
                }}
              />
              <div
                className={styles.typeSignatureBox}
                ref={typesSignatureBoxRef}
                key={typedSignature + forceRender}
              >
                {typedSignature}
              </div>
              {/* Hidden off-screen canvas */}
              <canvas ref={offscreenCanvasRef} style={{ display: 'none' }} />
            </div>
          ) : (
            <div className={styles.contentContainer}>
              <p className={styles.inputLabel}>Draw Signature</p>
              <div className={styles.drawSignatureBox}>
                <SignatureCanvas
                  ref={signedCanvasRef}
                  penColor="black"
                  canvasProps={{
                    className: styles.signatureCanvas,
                  }}
                  onEnd={() => {
                    // Save the drawn signature whenever it changes
                    const originalCanvas = signedCanvasRef.current.getTrimmedCanvas();
                    const originalWidth = originalCanvas.width;
                    const originalHeight = originalCanvas.height;

                    // Set the target width (600) and calculate proportional height
                    const targetWidth = 600;
                    const targetHeight = (originalHeight / originalWidth) * targetWidth;

                    // Create a new canvas for resizing
                    const resizeCanvas = document.createElement('canvas');
                    resizeCanvas.width = targetWidth;
                    resizeCanvas.height = targetHeight;

                    const ctx = resizeCanvas.getContext('2d');
                    ctx.drawImage(originalCanvas, 0, 0, targetWidth, targetHeight);

                    // Get the resized signature as a data URL
                    const resizedImageURL = resizeCanvas.toDataURL('image/png');

                    setDrawSignImage(resizedImageURL);
                  }}
                />
              </div>
            </div>
          )}

          <div className={styles.contentContainer}>
            <p className={styles.clear} onClick={handleClear}>
              x clear
            </p>
            <p className={`${styles.label} ${isMobile ? styles.mobile : ''} `}>
              By clicking “Sign” I, {userPersonalInfo?.firstName}{' '}
              {userPersonalInfo?.lastName}, acknowledge this as my legal signature and
              agree to FITNESS SF's Membership Agreement,{' '}
              <a href={termsOfServiceUrl} className={styles.link} target="_blank">
                Terms Of Service
              </a>
              , and{' '}
              <a href={privacyPolicyUrl} className={styles.link} target="_blank">
                Privacy Policy
              </a>
              . I confirm that I am at least 18 years old.
            </p>
            <div className={styles.buttonWrapper}>
              <button
                onClick={handleNext}
                className={
                  !isTabsEnabled ||
                  (activeSignTab === 'type' && !typedSignature.trim()) ||
                  (activeSignTab === 'draw' && !drawSignImage)
                    ? styles.disableSubmitButton
                    : styles.submitButton
                }
                disabled={
                  !isTabsEnabled ||
                  (activeSignTab === 'type' && !typedSignature.trim()) ||
                  (activeSignTab === 'draw' && !drawSignImage)
                }
              >
                Sign
              </button>
            </div>
          </div>
        </div>

        <div className={styles.mainScroll} />
        <BackButton onBack={() => handleBack()} backButtonName="Back" />
        <Dialog
          open={isCancellationPopupOpen}
          onClose={() => setIsCancellationPopupOpen(false)}
          classes={{ paper: styles.dialogPaper }}
        >
          <div className={styles.wrapper}>
            <div className={styles.closeIcon}>
              <img
                onClick={() => setIsCancellationPopupOpen(false)}
                src={buddyReferralCloseIcon}
                alt="close icon"
              />
            </div>
            <div className={styles.content}>
              <div
                dangerouslySetInnerHTML={{
                  __html: termsTextData?.cancelingmymembership_text,
                }}
              />
            </div>
          </div>
        </Dialog>
      </div>
    </>
  );
};

TermsConditions.propTypes = {
  plan: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default TermsConditions;
